import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=28d613d1&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=28d613d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d613d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d613d1')) {
      api.createRecord('28d613d1', component.options)
    } else {
      api.reload('28d613d1', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=28d613d1&scoped=true&", function () {
      api.rerender('28d613d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/Avatar.vue"
export default component.exports